import { NgModule } from '@angular/core';
import { FormFieldComponent } from './components/form-field.component';

@NgModule({
  exports: [FormFieldComponent],
  imports: [FormFieldComponent],
})
export class FormFieldModule {}
